
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Learn how to handle refunds for Payment Initiation transactions.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Refunds' subtitle='Handle refunds for Payment Initiation transactions' mdxType="Header" />
    <h4 {...{
      "id": "refunding-payments"
    }}>{`Refunding payments`}</h4>
    <p>{`For Payment Initiation (without Virtual Accounts), refunds can be executed using your banking partner to send funds to a user's bank account.`}</p>
    <p>{`When calling `}<inlineCode parentName="p">{`/payment_initiation/payment/create`}</inlineCode>{` you can set `}<inlineCode parentName="p">{`options.request_refund_details`}</inlineCode>{` to `}<inlineCode parentName="p">{`true`}</inlineCode>{`. If you do, the refund details (account number and sort code) will be available in the `}<inlineCode parentName="p">{`/payment_initiation/payment/get`}</inlineCode>{` response. You can then use your banking partner to push a refund to the end-user requesting a refund. Support varies across financial institutions and will not always be available.`}</p>
    <p>{`Alternatively, if you have used Plaid's `}<a parentName="p" {...{
        "href": "/docs/auth/"
      }}>{`Auth`}</a>{` product for account verification before making a payment, you will also have access to the user's bank account details.`}</p>
    <p>{`For streamlined refunds via Plaid, see `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts/"
      }}>{`Virtual Accounts`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "refunding-payments",
        level: 4,
        title: "Refunding payments",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
